import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { logout } from "../store/authSlice";
import { changeStatus } from "../store/urlSlice";
import Flags from "./Flags";

function MobSettings() {
  const [show, setShow] = useState(false);
  const { t } = useTranslation();
  const userFullName = useSelector(state => state.auth.userFullName);
  const dispatch = useDispatch();
  const handleLogout = () => {
    dispatch(logout());
    dispatch(changeStatus({ status: null }));
  };

  return (
    <ul className="mob-settings">
      <li className="profile">
        <p>
        <i className="fa-solid fa-id-card" style={{ marginRight: "10px" }}></i>
        <span>{userFullName}</span>
        </p>
        <button onClick={handleLogout} className="outButton">

        <i
          className="fa-solid fa-arrow-right-from-bracket"
          
        ></i>
        {/* {t("Logout")} */}
        </button>
      </li>
      <li>{<Flags />}</li>
      <li className={!show ? "ssshow" : "hhhide"}>
        <ul className={"currency " + (!show ? "" : "currency_hide")}>
          <li className="currency">
          <i class="fa-solid fa-manat-sign"></i>
            <span>
              1.00 <i className="fa-solid fa-arrow-up"></i>
            </span>
          </li>
          <li className="currency">

          <i class="fa-solid fa-dollar-sign"></i>
            <span>
              1.70 <i className="fa-solid fa-arrow-up"></i>
            </span>
          </li>
          <li className="currency">
            <span>
              1.80 <i className="fa-solid fa-arrow-up"></i>
            </span>
            <i class="fa-solid fa-euro-sign"></i>
          </li>
        </ul>
      </li>
      {/* {backtype.map(c => {
        return (
          <li>
            <label>
              <input
                type="radio"
                name="backtype"
                value={c.value}
                key={c.value}
                onClick={_backUpType}
                defaultChecked={c.value === backUpType}
              />
              {c.name}
            </label>
          </li>
        );
      })} */}
    </ul>
  );
}

export default MobSettings;
